'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var translations = {
    prefix: 'allbin_bar_',
    "sv-SE": {
        a_tool_by_allbin: 'ett verktyg av All Binary',
        account_information: 'kontoinformation',
        change_password: 'byt lösenord',
        changed: 'ändrat',
        changelog: 'versionshistorik',
        company_info: 'vi underl\xE4ttar analys och planering av kollektivtrafiken genom att visualisera data fr\xE5n realtidssystem\n            och biljettsystem samt skapar verktyg f\xF6r inventering av h\xE5llplatser och \xE4rendehantering',
        company_motto: 'att resa tillsammans har aldrig varit viktigare',
        contact: 'kontakt',
        email_us: 'skicka epost till oss',
        email: 'epost',
        first_name: 'förnamn',
        fixed: 'åtgärdat',
        help: 'hjälp',
        language: 'språk',
        last_name: 'efternamn',
        log_out: 'logga ut',
        logged_in_as: 'inloggad som',
        new: 'nytt',
        reset_password_info: 'när du klickar på knappen skickas ett epost till följande adress med instruktioner',
        sent: 'skickat',
        to_dashboard: 'till Dashboard',
        updated: 'uppdaterat',
        username: 'användarnamn'
    },
    "en-US": {
        a_tool_by_allbin: 'a tool by All Binary',
        account_information: 'account information',
        change_password: 'change password',
        changed: 'changed',
        changelog: 'change log',
        company_info: 'we ease analysis and planning of public transportation by visualizing data from realtime\n            and ticket systems and creating tools for inventory and task management',
        company_motto: 'traveling together has never been easier',
        contact: 'contact',
        email_us: 'email us',
        email: 'email',
        first_name: 'first name',
        fixed: 'fixed',
        help: 'help',
        language: 'language',
        last_name: 'last name',
        log_out: 'log out',
        logged_in_as: 'logged in as',
        new: 'new',
        reset_password_info: 'when you click the button an email will be sent to the follow address with instructions',
        sent: 'sent',
        to_dashboard: 'to Dashboard',
        updated: 'updated',
        username: 'username'
    }
};

exports.default = translations;


//////////////////
// WEBPACK FOOTER
// ./node_modules/allbin-bar/dist/translations.js
// module id = 165
// module chunks = 0